import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function VwMsgTrash ( props ) {

    const { onSelect, onInitialized, ...others } = props;

    const onGridInitialized = (grid) => {

        grid.selectionMode = "ListBox";
        
        if (grid) {

            grid.selectionChanged.addHandler((grid, event) => {

                if ( grid.selectedItems ) {

                    if ( onSelect ) {

                        onSelect ( grid.selectedItems );

                    }

                }

            });

            grid.itemsSourceChanged.addHandler((grid, event) => {

                if ( grid.selectedItems ) {

                    if ( onSelect ) {

                        onSelect ( grid.selectedItems );
                        
                    }

                }

            });

        }

        if ( onInitialized ) {

            onInitialized ( grid );

        }

    };

    return <BasicCrudScreenType id="VwMsgTrash" table="VwMsgTrash" view="VwMsgTrash" {...others} onInitialized={onGridInitialized} />

}

export default VwMsgTrash;

